import React from "react";
import { Box, Button, Paper } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import AddMrvModal from "./AddMrvModal";
import PoDetails from "./PoDetails";
import PaymentModal from "./PaymentModal";

import { taggedMrqMaterialsCols } from "../../BOMTab/Components/cols/mrqMaterialsCols";
import { mrqMaterialsMcsDataCols } from "../../BOMTab/Components/cols/mrqMaterialsMcsCols";
import { lightTable } from "../../../../../../../styles/muiProps";
import DescriptionIcon from "@mui/icons-material/Description";
import { usePOPageContext } from "./POPageContext";
import moment from "moment";

export default function PoMangerMain() {
  const { selectedPo } = usePOPageContext();

  const [openAddMrvModal, setOpenAddMrvModal] = React.useState(false);
  const [selectedPoMaterials, setSelectedPoMaterials] = React.useState([]);
  const [selectedDrawingMaterials, setSelectedDrawingMaterials] =
    React.useState([]);

  const initDate = selectedPo?.createdAt;

  const poDate = new Date(initDate);
  const formattedData = (materials) => {
    console.log({ materials });
    return materials?.map((pm) => {
      // console.log("pm", pm);
      return {
        materials: pm.mrqMaterial?.materials,
        costCode: pm.mrqMaterial?.materials?.[0]?.costCode,
        description: pm.mrqMaterial?.description,
        quantity: pm.mrqMaterial?.procuredQty,
        procuredUnit: pm.mrqMaterial?.procuredUnit,
        mrvQuantity: pm.mrqMaterial?.quantity,
        mrvMrqMaterials: pm.mrqMaterial?.mrvMrqMaterials,
        heatNumber: pm.mrqMaterial?.heatNumber,
        remarks: pm.mrqMaterial?.remarks,
        ...pm.mrqMaterial,
        cost: pm.cost,

        id: [pm.mrqMaterial?.id],

        initAmount: (pm.cost * 30) / 100,
        initDate: moment(initDate).format("YYYY-MM-DD") || "",
        arrivedAmount: (pm.cost * 30) / 100,
        arrivedDate:
          moment(poDate.setDate(poDate.getDay() + pm?.time)).format(
            "YYYY-MM-DD",
          ) || "",
        after30Amount: (pm.cost * 30) / 100,
        after30Date: "",
      };
    });
  };

  const table = useMaterialReactTable({
    data: formattedData(selectedPo?.poMaterials) || [],
    columns: [
      ...taggedMrqMaterialsCols(),

      {
        accessorKey: "x",
        header: "",
        columns: [
          {
            accessorKey: "doc",
            header: "Doc",
            grow: false, //don't allow this column to grow to fill in remaining space
            size: 60,
            muiTableHeadCellProps: {
              align: "center",
            },
            Cell: ({ row }) => {
              return (
                <Box sx={{ textAlign: "center" }}>
                  {row.original.heatNumber && (
                    <DescriptionIcon sx={{ color: "#444" }} />
                  )}
                </Box>
              );
            },
          },
          ...mrqMaterialsMcsDataCols.filter(
            (c) =>
              !["mrqNumber", "poNumber", "srvNumber"].includes(c.accessorKey),
          ),
        ],
      },
    ],
    ...lightTable,

    enableRowSelection: true,
  });

  const selectedRows = table.getSelectedRowModel();
  const onAddToMrv = () => {
    setSelectedDrawingMaterials([]);
    setOpenAddMrvModal(true);
    setSelectedPoMaterials(
      selectedRows.rows.map((r) => {
        return { ...r.original, id: r.original.id[0] };
      }),
    );
  };

  return (
    <Box sx={{ ml: 3 }}>
      {selectedPo?.id && (
        <Box sx={{ display: "flex", gap: "2rem", mt: 2 }}>
          <Paper sx={{ flex: 1, p: 2 }} elevation={1}>
            <PoDetails po={selectedPo} />
          </Paper>
          <Paper sx={{ flex: 2, minWidth: 320, p: 2 }} elevation={1}>
            <PaymentModal poId={selectedPo.id} po={selectedPo} />
          </Paper>
        </Box>
      )}

      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
          <AddMrvModal
            openAddMrvModal={openAddMrvModal}
            setOpenAddMrvModal={setOpenAddMrvModal}
            selectedPoMaterials={selectedPoMaterials}
            setSelectedPoMaterials={setSelectedPoMaterials}
            selectedDrawingMaterials={selectedDrawingMaterials}
            setSelectedDrawingMaterials={setSelectedDrawingMaterials}
          />
          <Button
            variant="contained"
            disabled={!selectedRows.rows[0]}
            onClick={onAddToMrv}
          >
            Add to MRV
          </Button>
        </Box>
        <MaterialReactTable table={table} />
      </Box>
    </Box>
  );
}
